import { jsx as _jsx } from "react/jsx-runtime";
import { useRecoilValue } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { SummarySection } from '@zurich/ui/legacy/components';
import { offerDetailsAtom } from '../../../recoil/atoms/policy';
// host wrongly interpreted an id as a double, so we need to fix it here...
function cutoffAfterComma(str) {
    return str ? str.split(',').shift() : str;
}
export function PolicyDetailInsuranceConfirmationSummary() {
    const { t } = useTranslation();
    const offer = useRecoilValue(offerDetailsAtom);
    const productFeatureOptionsMotor = offer?.products?.[0].productFeatures?.find((productFeature) => productFeature.productfeatureType === 'pF_AddOnOptionsMotor') || {};
    const insuranceConfirmationNumber = 'insuranceConfirmationNumber' in productFeatureOptionsMotor
        ? productFeatureOptionsMotor.insuranceConfirmationNumber
        : undefined;
    const insuranceConfirmationData = [
        {
            label: t('policy.insuranceConfirmationNumber'),
            value: cutoffAfterComma(insuranceConfirmationNumber),
        },
    ];
    return (_jsx(SummarySection, { rows: insuranceConfirmationData, title: t('policy.insuranceConfirmation'), editable: false }));
}
